import type { SubscriptionResponse } from '../services/subscription'

export const IS_FREE_ACCESS_MODE = true

export const FREE_ACCESS_SUBSCRIPTION: SubscriptionResponse = {
  id: 'free-access',
  plan_key: 'professional',
  shop_id: 0,
  status: 'active',
  created_at: '1970-01-01T00:00:00Z',
  updated_at: '1970-01-01T00:00:00Z',
  plan_snapshot: {
    id: 'professional',
    plan_key: 'professional',
    name: 'Professional',
    price: 39,
    currency: 'USD',
    billing_interval: 'month',
    trial_days: 0,
    most_popular: false,
    status: 'active',
    sort_order: 3,
    features: ['custom-cost-tracking'],
    integration: 9999,
    account_per_channel: 9999,
    terms: '',
    capped_amount: 0,
    annual_paid: false,
    annual_discount: 0,
    shopify_plan_id: '',
  },
  features: ['custom-cost-tracking'],
  charge_id: 0,
}
